export enum RemarkTypes {
  CustomerFirstRemark = 1,
  PbhNote = 2,
  UnserviceableFirstRemark = 3,
  ShopNote = 4,
  PbhRejectNote = 5,
  EightWingsTTNotVerifiedRemark = 6,
}
